import { 
  Box, Button, Flex, Text, Input, Select, InputLeftElement, Radio, RadioGroup, Stack, Table, Thead, Tbody, Tr, Th, Td, InputGroup 
} from "@chakra-ui/react";
import { LuSearch } from "react-icons/lu";
import { useState } from "react";

const Clients = () => {
  const [radioValue, setRadioValue] = useState("all");

 // Dummy data for table rows
const requestData = [
  {
    client: "HSBC",
    businessLine: "Workplace Solutions",
    Membersince: "12/11/24 ",
    activemodules: "7",
    readyForInvoice: "10",
    outstandingRequests: "3",
    activeJobs:"7",
    badDebt: "£0",
  },
  {
    client: "Conservatives",
    businessLine: "Lead Supply",
    Membersince: "12/11/24 ",
    activemodules: "7",
    readyForInvoice: "10",
    outstandingRequests: "3",
    activeJobs:"7",
    badDebt: "£0",
  },
  {
    client: "Bupa",
    businessLine: "Workplace Solutions",
    Membersince: "12/11/24 ",
    activemodules: "7",
    readyForInvoice: "10",
    outstandingRequests: "3",
    activeJobs:"7",
    badDebt: "£0",
  },
  {
    client: "The Post Office",
    businessLine: "Workplace SolutionsLead Supply",
    Membersince: "12/11/24 ",
    activemodules: "7",
    readyForInvoice: "10",
    outstandingRequests: "3",
    activeJobs:"7",
    badDebt: "£0",
  },
];

  return (
    <Box flex="1" pt="40px" px="8">
      {/* Header */}
      <Flex justify="space-between" align="center" mb={6}>
        <Text  fontSize="30px" color="#101828">Clients</Text>
        <Button background="#1e98d7" color="#ffffff" _hover="none" fontSize="14px"> Add a new client</Button>
      </Flex>

      {/* Filters Section */}
      <Flex gap={4} wrap="wrap" mb={6}>
      <InputGroup flex="1" maxW={{ base: "180px", md: "270px" }}>
          <InputLeftElement pointerEvents="none">
            <LuSearch color="#999999" />
          </InputLeftElement>
          <Input placeholder="Search" fontSize="12px" />
        </InputGroup>
        <Select placeholder="Business line (0)" fontSize="12px" color="#667085" width="180px" >
          <option value="option1">Artwork</option>
          <option value="option2">Quote</option>
        </Select>

        <Select placeholder="Priority (0)" fontSize="12px" color="#667085" width="180px" >
          <option value="option1">Artwork</option>
          <option value="option2">Quote</option>
        </Select>
      </Flex>

      {/* Radio Buttons */}
      <RadioGroup onChange={setRadioValue} value={radioValue} mb={12} color="#475467">
  <Stack direction="row" align="center" color="#475467" >
    <Text fontWeight="semibold" fontSize="12px" color="#475467" mr={4}>View:</Text>
    <Radio value="all"  mr={4}>
        <Text fontSize="12px">All clients</Text>
    </Radio>
    <Radio value="approved"  mr={4}>
        <Text fontSize="12px">My clients</Text>
    </Radio>
   
  </Stack>
</RadioGroup>



      {/* Responsive Table */}
      <Box overflowX="auto">
        <Table variant="simple">
          <Thead >
            <Tr >
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Client</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Business Line</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Member since</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Active modules</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Ready for invoice</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Outstanding requests</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Active jobs</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Bad debt</Th>
              <Th  pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold"></Th>
            </Tr>
          </Thead>

          <Tbody>
            {requestData.map((request, index) => (
              <Tr key={index} >
                <Td pl={0} py={7} color="#475467" fontSize="12px">{request.client}</Td>
                <Td pl={0} color="#475467" fontSize="12px">{request.businessLine}</Td>
                <Td pl={0} color="#475467" fontSize="12px">{request.Membersince}</Td>
                <Td pl={0} color="#475467" fontSize="12px">{request.activemodules}</Td>
                <Td pl={0}color="#475467" fontSize="12px">{request.readyForInvoice}</Td>
                <Td pl={0} color="#475467" fontSize="12px">{request.outstandingRequests}</Td>
                <Td pl={0} color="#475467" fontSize="12px">{request.activeJobs}</Td>
                <Td pl={0} color="#475467" fontSize="12px">{request.badDebt}</Td>
                <Td pl={0} color="#475467" fontSize="12px" textDecoration="underline" cursor="pointer">View</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default Clients;
